import { Component, OnInit } from '@angular/core';

import { FirebaseListObservable } from 'angularfire2/database-deprecated';
import { Video } from './shared/video';
import { VideoService } from './shared/video.service';
import {DomSanitizer} from '@angular/platform-browser';

@Component({
  selector: 'watch',
  templateUrl: './watch.component.html',
  styleUrls: ['./watch.component.scss']
})

export class WatchComponent implements OnInit {
    
   public videos: FirebaseListObservable<Video[]>;
   public trails: String[];
   public domain: String;
   public activeTrail: String;
  constructor(private videoService: VideoService, private sanitizer:DomSanitizer) { }

  ngOnInit() {
    this.videos = this.videoService.getVideoList();
    this.domain = window.location.hostname;
    this.videos.subscribe((_videos) => {
        this.trails = _videos.reduce<Array<String>>((all: String[], el: Video) => {
            if(!all.includes(el.trail)) all.push(el.trail);
            return all;
        }, new Array<String>());
        this.activeTrail = this.trails[0];
    })
  }

  changeTrail(trail: string) {
      this.activeTrail = trail;
  }

  getLiveURL(code: string) {
    const url = `https://www.youtube.com/embed/${code}`;
    return url;
  }

  getChatURL(code: string) {
    const url = `https://www.youtube.com/live_chat?v=${code}&embed_domain=${this.domain}`
    return url;
  }

}
